module.exports = __webpack_public_path__ + "img/arrecredi_bdon_1.8c881a21.webp";